import { get } from "../utils/request";
//菜单 -> 获取LOGO
export const getLogoConfig = (params) => get('/config/init', params);
export const getNavList = (params) => get('/config/init', params);
